import React, { useState, useRef } from 'react';
import { Formik, Form } from 'formik';
import { useHistory } from 'react-router';
import * as Yup from 'yup';
import Box from '@material-ui/core/Box';
import { LOGOUT } from 'ConstComponents';
import { NSDLBank3SenderEKYC as SENDER_EKYC } from 'Components/Api/NovityDMTAPI';
import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import { Container, Grid, Paper, Button } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { PLEASE_PROVIDE_VALID } from 'Components/Helper/Messages';
import { useLocation } from 'react-router-dom';
import HOCLoader from 'Components/Loader/HOCLoader';
import { PrimaryButton } from 'Components/Inputes/CustomButton';
import usePosition from 'Components/Posistion';
import { GetFingerPrint } from 'Components/FingerPrintProcessing';

const CustomContainer = HOCLoader(Container);

export const NSDLBank3SenderAdharVerifyEKYC = () => {
    const formRef = useRef();
    const classes = commonStyle();
    const history = useHistory();
    const location = useLocation();
    const { latitude, longitude } = usePosition();
    const Mobile = location?.state?.Mobile;
    const BankPipe = location?.state?.BankPipe;
    const ActiveDMTName = location?.state?.DMTName;
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [formObject, setFormObject] = useState({
        SenderMobile: Mobile,
        BankPipe: BankPipe,
        DMTName: ActiveDMTName,
        Latitude: latitude,
        Longitude: longitude,
        SenderAadhaarNumber: '',
        WADH: 'TF/lfPuh1n4ZY1xizYpqikIBm+gv65r51MFNek4uwNw=',
        PID: ''
    });

    const submitHandle = async (values) => {
        setLoading(true);
        const { status, xmldata } = await GetFingerPrint(values.WADH);

        if (status === false) {
            alert(xmldata);
            return;
        }
        let fingerPrintXML = xmldata;

        const inputObj = {
            MobileNo: values.SenderMobile,
            DMTName: values.DMTName,
            AdharNo: values.SenderAadhaarNumber,
            PID: fingerPrintXML
        };
        values.Latitude = latitude;
        values.Longitude = longitude;
        var reqObj = JSON.stringify(inputObj);
        var response = await SENDER_EKYC(reqObj);
        setLoading(false);
        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setSeverity('error');
            setResponseMessage(response.data);
            setIsError(true);
            return;
        }

        var result = JSON.parse(response.data);
        setSeverity('success');
        setResponseMessage(result.Message);
        setIsError(true);
        let params = {
            Mobile: values.SenderMobile,
            AdharNo: values.SenderAadhaarNumber,
            BankPipe: BankPipe,
            DMTName: ActiveDMTName
        };
        history.push('/NTDMT_NSDLBankSenderAdd', params);
    };

    const FormValidationSchema = Yup.object({
        SenderMobile: Yup.string()
            .required(PLEASE_PROVIDE_VALID + 'mobile')
            .length(10, PLEASE_PROVIDE_VALID + 'mobile'),
        SenderAadhaarNumber: Yup.string()
            .required(PLEASE_PROVIDE_VALID + 'Aadhaar number')
            .length(12, PLEASE_PROVIDE_VALID + 'Aadhaar number')
    });

    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                innerRef={formRef}
                enableReinitialize={true}
                initialValues={formObject}
                validationSchema={FormValidationSchema}
                onSubmit={submitHandle}
                resetForm={formObject}
            >
                {({ values, errors, setFieldValue }) => {
                    return (
                        <Form>
                            <Grid
                                item
                                container
                                margin="normal"
                                xs={12}
                                md={12}
                                sm={12}
                                lg={12}
                                spacing={2}
                                style={{
                                    justifyContent: 'center'
                                }}
                            >
                                <Grid item xs={12} sm={12} md={4} lg={4}>
                                    <h2 className={classes.PaperHead_h2}>
                                        NSDL Bank Sender Aadhaar VerifyEKYC
                                    </h2>
                                    <Grid item xs={12}>
                                        <Paper className={classes.PaperStyle}>
                                            <Grid container spacing={2}>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <MaterialTextField
                                                        label="Mobile Number"
                                                        name="SenderMobile"
                                                        type="text"
                                                        length={10}
                                                        placeholder="Mobile Number"
                                                        readOnly={true}
                                                    />
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <MaterialTextField
                                                        label="Aadhar Number"
                                                        name="SenderAadhaarNumber"
                                                        type="text"
                                                        length={12}
                                                        placeholder="AadharNo"
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Paper>
                                    </Grid>

                                    <Grid className={classes.footerGrid}>
                                        <Box
                                            className={classes.flexReverse}
                                            sx={{ gap: '16px' }}
                                        >
                                            <div
                                                className={
                                                    classes.SubmitWrapper
                                                }
                                            >
                                                <PrimaryButton
                                                    type="submit"
                                                    title="Continue to Scan"
                                                    style={{
                                                        width: '180px'
                                                    }}
                                                    className={
                                                        classes.CustomDMTButtonStyle
                                                    }
                                                    disabled={loading}
                                                />
                                                {loading && (
                                                    <CircularProgress
                                                        size={24}
                                                        className={
                                                            classes.buttonProgress
                                                        }
                                                    />
                                                )}
                                            </div>
                                            <Button
                                                variant="contained"
                                                style={{
                                                    backgroundColor: '#D5006D',
                                                    color: 'white',
                                                    width: '90px',
                                                    marginLeft: '16px'
                                                }}
                                                onClick={() => {
                                                    history.push(
                                                        '/NTDMT_NSDLBankSenderAdd',
                                                        {
                                                            Mobile: Mobile,
                                                            BankPipe: BankPipe,
                                                            DMTName: ActiveDMTName,
                                                            Name: ''
                                                        }
                                                    );
                                                }}
                                            >
                                                Back
                                            </Button>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Form>
                    );
                }}
            </Formik>
        </CustomContainer>
    );
};
